import setGrabCursor from './setGrabCursor';
import unsetGrabCursor from './unsetGrabCursor';
export default {
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
};


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/web/app/themes/mea/node_modules/swiper/esm/components/core/grab-cursor/index.js
// module id = 1094
// module chunks = 0